import React, { useContext } from 'react'
import CarContext from '../../context/CarContext'

const MobileMenu = () => {
    const {setShouldShowEcomModal, car} = useContext(CarContext)

    return (
        <div className="mobile-menu btn-group">
            <a 
                href="#kop" 
                title="Köp"
                className="text-block passion"
                onClick={(e)=>{
                    e.preventDefault()
                    setShouldShowEcomModal(true)
                }}
            >Köp</a>
            <a 
                href={`tel:${car.branch.phone}`} 
                title={`Ring ${car.branch.name}`}
                className="text-block black"
            >Ring säljare</a>
        </div>
    )
}

export default MobileMenu;